module.exports = __webpack_public_path__ + "img/D201812_2.ea5fb134.jpg";